module.exports = __webpack_public_path__ + "img/FGr_Schwere_Bergung_B.1303f447.svg";